<template>
  <div class="AdminShippingListMdMicrodetectors">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Lista Consegne</router-link>
      </li>
    </ol>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabOCList" role="tabpanel">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <!--
                  <button
                    class="btn btn-primary btn-block"
                    @click="clickNewOrder"
                    type="button"
                  >
                    <i class="fa fa-barcode"></i>
                    Nuovo
                  </button>
                  -->
                  <div id="dManualInput" v-if="manualInput">
                    <form id="frmBarcodeReaderOrder" @submit.prevent="submitBarcodeOrder">
                      <div class="row">
                        <div class="col-sm-12 col-lg-12">
                          <!-- @keyup="submitBarcodeOrder" -->
                          <input
                            @keyup="controlTimeIntervalShipping"
                            autocomplete="off" 
                            autocorrect="off" 
                            autocapitalize="off" 
                            spellcheck="false"
                            type="none"
                            inputmode="none"
                            id="txtBarcodeReaderOrder"
                            name="txtBarcodeReaderOrder"
                            ref="txtBarcodeReaderOrder"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <bootstrapTable
                    :configurations="tableOCListConfiguration"
                    :datas="tableOCListData"
                    id="tableOCList"
                    :onClickRow="onClickOCList"
                    ref="tableOCList"
                  ></bootstrapTable>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabItemList" role="tabpanel">
            <div class="card" v-show="orderSelected == ''">
              <div class="card-header">
                <div class="row">
                  <div class="col">Nuova consegna</div>
                </div>
              </div>
              <div class="card-body" style="padding: 5px">
                
                <div id="scannerInput" v-if="!manualInput">
                  <div class="row">
                    <div class="col">
                      <!--
                      <barcodeReaderMdMicrodetectors :value.sync="barcodeReaderDataOrder"></barcodeReaderMdMicrodetectors>
                      -->
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-right">
                      <button class="btn btn-success btn-block" @click="clickDisableScanner">
                        <i class="fa fa-barcode"></i>
                        Disabilita scanner
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card" v-show="orderFound" style="margin-bottom:0px;">
              <div class="card-header" >
                <div class="row">
                  <div class="col">
                    <b>{{ customer }}</b>
                  </div>
                  <div class="col text-right">
                    <b>Consegna</b>
                  </div>
                </div>
                <div class="row">
                  <div class="col">{{ customerSelected }}</div>
                  <div class="col text-right">{{ orderSelected }}</div>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12">
                    <bootstrapTable
                      :configurations="tableItemListConfiguration"
                      :datas="tableItemListData"
                      :onClickRow="onClickOCListItem"
                      filterControl="false"
                      singleSelect="false"
                      id="tableItemList"
                      ref="tableItemList"
                    ></bootstrapTable>
                  </div>
                </div>
                <!-- DIV LETTURA -->
              <div class="card" id="cardDetailArticle">
                  <div class="card-header">
                    <div class="row">
                      <div class="col"><b>LETTURA</b></div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="" v-if="manualInputArticle">
                      
                        <div class="row">
                          <div class="col-sm-12 col-lg-12 nopadding">
                            <form id="frmBarcodeReader" @submit.prevent="submitBarcodeArticle">
                              <input
                                @keyup="controlTimeIntervalArticle"
                                autocomplete="off" 
                                autocorrect="off" 
                                autocapitalize="off" 
                                spellcheck="false"
                                type="none"
                                inputmode="none"
                                id="txtBarcodeReader"
                                name="txtBarcodeReader"
                                ref="txtBarcodeReader"
                                class="form-control"
                                autofocus
                              />
                            </form>
                          </div>
                          <div class="col-4 nopadding div-feedback">
                            
                          </div>
                          <div class="col-4 nopadding">
                            <button
                              id="btnItemListBack"
                              type="button"
                              class="btn btn-primary btn-block"
                              @click="clickResetList"
                            >
                              <i class="fa fa-chevron-left"></i>
                              <span>Reset</span>
                            </button>
                          </div>
                          <div class="col-4 nopadding">
                            <button
                              id="btnItemListBack"
                              type="button"
                              class="btn btn-danger btn-block"
                              @click="itemListBack"
                            >
                              <i class="fa fa-chevron-left"></i>
                              <span>Indietro</span>
                            </button>
                          </div>
                        </div>
                    </div>
                    <div id="scannerInput" v-if="!manualInputArticle">
                      <div class="row">
                        <div class="col">
                          <!--
                          <BarcodeReaderMdMicrodetectorsArticle :value.sync="barcodeReaderData"></BarcodeReaderMdMicrodetectorsArticle>
                          -->
                        </div>
                      </div>
                      <div class="row">
                        <div class="col text-right">
                          <button class="btn btn-success btn-block" @click="clickDisableScannerArticle">
                            <i class="fa fa-barcode"></i>
                            Disabilita scanner
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              <!-- END DIV LETTURA -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarcodeReaderMdMicrodetectors from "@/components/BarcodeReaderMdMicrodetectors.vue";
import BarcodeReaderMdMicrodetectorsArticle from "@/components/BarcodeReaderMdMicrodetectorsArticle.vue";
import BootstrapTable from "@/components/BootstrapTable.vue";

export default {
  name: "AdminShippingListMdMicrodetectors",
  components: {
    BarcodeReaderMdMicrodetectors,
    BarcodeReaderMdMicrodetectorsArticle,
    BootstrapTable
  },
  data() {
    return {
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      chkToEscape: "no",
      idFrmBarcodeReader: 'frmBarcodeReader',
      idFrmBarcodeReaderOrder: 'frmBarcodeReaderOrder',
      barcodeReaderData: "",
      barcodeReaderDataOrder: "",
      customer: dictionaryHelpers.getDictionary("Customer"),
      customerSelected: "",
      idSelected: 0,
      idHeadSeleted: 0,
      idTabItemList: "tabItemList",
      idTabOCList: "tabOCList",
      ocList: dictionaryHelpers.getDictionary("OCList"),
      order: dictionaryHelpers.getDictionary("Order"),
      orderSelected: "",
      picking: dictionaryHelpers.getDictionary("Picking"),
      startReading: dictionaryHelpers.getDictionary("StartReading"),
      tableItemListConfiguration: [],
      tableItemListData: [],
      tableItemListFilterBy: {},
      tableOCListConfiguration: [],
      tableOCListData: [],
      toEscape: dictionaryHelpers.getDictionary("ToEscape"),
      url: window.location.pathname,
      manualInput: true,
      manualInputArticle: true,
      orderFound: false,
      scannedArticle : "",
      typingTimer: "",
      doneTypingInterval: 5000
    };
  },
  watch: {
    chkToEscape: function(newVal, oldVal) {
      if (newVal == "yes") {
        this.tableItemListFilterBy = { pickingState: [0, 1] };
      } else {
        this.tableItemListFilterBy = "";
      }
    },
    barcodeReaderData: function(newVal, oldVal) {
      /*var adminPickingReadingMd = this;
      if (functionHelpers.isValued(newVal)) {
        //this.barcodeReaderData = newVal;
        this.manualInputArticle = true;
        //this.checkShippingRow();
      }*/
    },
    barcodeReaderDataOrder: function(newVal, oldVal) {
      /*var adminPickingReadingMd = this;
      if (functionHelpers.isValued(newVal)) {
        this.orderSelected = newVal;
        this.manualInput = true;
        $("#" + this.idTabOCList).removeClass("active");
        $("#" + this.idTabItemList).addClass("active");
        this.loadItemTableData();
      }*/
    },
    $route(to, from) {
      if (!functionHelpers.isValued(to.params.id)) {
        this.loadOCListTableData();
        $("#" + this.idTabOCList).addClass("active");
        $("#" + this.idTabItemList).removeClass("active");
      }
    }
  },
  created() {
    spinnerHelpers.show();
    this.loadConfiguration();
  },
  methods: {
    newOrder(){
      this.idSelected = 0;
      this.orderFound = false;
      this.orderSelected = '';
      $("#" + this.idTabOCList).removeClass("active");
      $("#" + this.idTabItemList).addClass("active");
    },
    /*** TIME INTERVAL ***/
    controlTimeIntervalShipping(){
      var adminSettingUser = this;
      clearTimeout(this.typingTimer); 
      this.typingTimer = setTimeout(function() { 
         adminSettingUser.submitBarcodeOrder();
      }, 200);
    },
    controlTimeIntervalArticle(){
      var adminSettingUser = this;
      clearTimeout(this.typingTimer); 
      this.typingTimer = setTimeout(function() { 
         adminSettingUser.submitBarcodeArticle();
      }, 200);
    },
    /*** END TIME INTERVAL ***/
    /***   OC LIST   ***/

    loadConfiguration() {
      var adminSettingUser = this;

      adminConfigurationServices.getFunctionality(function(result) {
        if (
          functionHelpers.isValued(result) && functionHelpers.isValued(result.data)) {
          adminSettingUser.tableOCListConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
          adminSettingUser.tableItemListConfiguration = result.data.tablesConfigurations[1].tablesConfigurations;
        }
        adminSettingUser.loadOCListTableData();
      });
    },
    loadOCListTableData() {
      var adminSettingUser = this;
      documentHeadServices.getMdMicrodetectorsShippingList(function(result) {
        adminSettingUser.tableOCListData = result.data;
        
       /* $('#txtBarcodeReaderOrder').attr('readonly', 'readonly');
        $('#txtBarcodeReaderOrder').attr('disabled', 'true');
        setTimeout(function() {
            $('#txtBarcodeReaderOrder').blur();
            $('#txtBarcodeReaderOrder').removeAttr('readonly');
            $('#txtBarcodeReaderOrder').removeAttr('disabled');
        }, 100);*/
        
        setTimeout(function(){ 
          adminSettingUser.$refs.txtBarcodeReaderOrder.focus();
        }, 10);
        spinnerHelpers.hide();
      });
    },
    onClickOCList(row, element, field) {
      spinnerHelpers.show();
      this.idSelected = row.id;
      this.customerSelected = row.customerDescription;
      this.orderSelected = row.orderNumber;
      this.chkToEscape = "yes";
      this.loadItemTableData();
      $("#" + this.idTabOCList).removeClass("active");
      $("#" + this.idTabItemList).addClass("active");
      this.$router.push({ path: `/admin` });
    },
    onClickOCListItem(row, element, field){
      var adminSettingUser = this;
      if (confirm("Sei sicuro di voler modificare lo stato dell'articolo " + row.itemCode)) {
        //this.executeSaveData();
        adminSettingUser.barcodeReaderData = row.itemCode;
        adminSettingUser.checkShippingRow(true);
      }
      
    },
    clickNewOrder(){
      this.orderFound = false;
      this.orderSelected = '';
      $("#" + this.idTabOCList).removeClass("active");
      $("#" + this.idTabItemList).addClass("active");
      this.$router.push({ path: `/admin` });
    },

    /***   END OC LIST   ***/

    /***   ITEM LIST   ***/

    loadItemTableData() {
      var adminSettingUser = this;
      if(this.orderSelected!=''){
        documentRowServices.getMdMicrodetectorsByHead(this.orderSelected, function(result) {
          if(result.data.length > 0){
            adminSettingUser.tableItemListData = result.data;
            adminSettingUser.orderFound=true;
            //adminSettingUser.$router.push({ path: `/admin/picking/shipping/${adminSettingUser.orderSelected}` });
            $('.div-feedback-order').html('');
            if(adminSettingUser.scannedArticle==""){
              $('.div-feedback').html('');
            }
            $("#" + adminSettingUser.idTabOCList).removeClass("active");
            $("#" + adminSettingUser.idTabItemList).addClass("active");
            
          }else{
            adminSettingUser.orderFound=false;
            $('.div-feedback-order').html('<div class="div-append-feedback-ko"><h3><i class="fa fa-exclamation" aria-hidden="true"></i> Consegna non trovata</h3></div>');
          }

         /* $('#txtBarcodeReader').attr('readonly', 'readonly'); 
          $('#txtBarcodeReader').attr('disabled', 'true'); 
          setTimeout(function() {
              $('#txtBarcodeReader').blur();
              $('#txtBarcodeReader').removeAttr('readonly');
              $('#txtBarcodeReader').removeAttr('disabled');
          }, 100);*/
          setTimeout(function(){
            adminSettingUser.$refs.txtBarcodeReaderOrder.value = "";
            adminSettingUser.$refs.txtBarcodeReader.focus();
          }, 10);
          spinnerHelpers.hide();
        });
      }
    },
    quantityStateFormatter(value, row, index, field) {
      switch (row.pickingState) {
        case true:
          return '<div class="text-left div-checked">' + row.quantity + '</div>';
          break;
        case false:
          return '<div class="text-left">' + row.quantity + '</div>';
          break;
      }
    },
    cellStateFormatter(value, row, index, field) {
      var cell = '&nbsp;';
      if(row.cell != null){
        cell = row.cell ;
      }
      switch (row.pickingState) {
        case true:
          return '<div class="text-left div-checked">' + cell + '</div>';
          break;
        case false:
          return '<div class="text-left">' + cell + '</div>';
          break;
      }
    },
    articleStateFormatter(value, row, index, field) {
      switch (row.pickingState) {
        case true:
          return '<div class="text-left div-checked">' + row.itemCode + '</div>';
          break;
        case false:
          return '<div class="text-left">' + row.itemCode + '</div>';
          break;
      }
    },
    goToStartReading() {
      this.$router.push({ path: `/admin/picking/readingmd` });
    },
    itemListBack() {
      var adminSettingUser = this;
      spinnerHelpers.show();
      $("#" + this.idTabOCList).addClass("active");
      $("#" + this.idTabItemList).removeClass("active");
      this.customerSelected = "";
      this.orderSelected = "";
      this.scannedArticle = "";
      this.$router.push({ path: `/admin` });
      
      /*$('#txtBarcodeReaderOrder').attr('readonly', 'readonly');
      $('#txtBarcodeReaderOrder').attr('disabled', 'true');
      setTimeout(function() {
          $('#txtBarcodeReaderOrder').blur();
          $('#txtBarcodeReaderOrder').removeAttr('readonly');
          $('#txtBarcodeReaderOrder').removeAttr('disabled');
      }, 100);*/
      
      setTimeout(function(){ 
        adminSettingUser.$refs.txtBarcodeReaderOrder.focus();
      }, 10);
      spinnerHelpers.hide();
    },
    clickResetList() {
      if (confirm("Sei sicuro di voler resettare lo stato della lista?")) {
        spinnerHelpers.show();
        var adminShippingMdMicrodetectors = this;
        var data = {
          id : this.orderSelected
        }
        documentRowServices.updateMdMicrodetectorsResetShippingRow(data, function(result) {
        
          if(result.data){
            adminShippingMdMicrodetectors.loadItemTableData();
          }
          spinnerHelpers.hide();
        });
      }
    },
    /***   END ITEM LIST   ***/
    clickEnableScanner() {
      this.manualInput = false;
    },
    clickEnableScannerArticle() {
      this.manualInputArticle = false;
    },
    clickDisableScanner() {
      this.manualInput = true;
    },
    clickDisableScannerArticle() {
      this.manualInputArticle = true;
    },
    submitBarcodeArticle() {
        if (validationHelpers.isValid($("#" + this.idFrmBarcodeReader))) {
          this.barcodeReaderData = this.$refs.txtBarcodeReader.value;
          this.checkShippingRow(false);
        }
    },
    submitBarcodeOrder() {
      if (validationHelpers.isValid($("#" + this.idFrmBarcodeReaderOrder))) {
        this.orderSelected = this.$refs.txtBarcodeReaderOrder.value;
        this.loadItemTableData();
      }
    },
    checkShippingRow(cancelStatus){
      if(this.barcodeReaderData!=''){
        //spinnerHelpers.show();
        var articleToCheck = this.barcodeReaderData;
        var adminShipping = this;
        
        var data = {
          cancelStatus : cancelStatus,
          idShipping : this.orderSelected,
          articleToCheck : articleToCheck
        }
        adminShipping.scannedArticle = articleToCheck;
        documentRowServices.updateMdMicrodetectorsShippingRow(data, function(result) {
          var strResult = result.message.split(' - ');
          if(strResult[0] == "1"){
            $('.div-feedback').html('<div class="div-append-feedback-ok"><h3>' + articleToCheck + ' - ' + strResult[1] + '</h3></div>');
            adminShipping.loadItemTableData();
          }else{
            if(strResult[0] == "0"){
              $('.div-feedback').html('<div class="div-append-feedback-ko"><h3>' + articleToCheck + ' - ' + strResult[1] + '</h3></div>');
              adminShipping.loadItemTableData();
            }else{
              $('.div-feedback').html('<div class="div-append-feedback-ko"><h3>Articolo già verificato</h3></div>');
              adminShipping.loadItemTableData();
            }
          } 
          adminShipping.$refs.txtBarcodeReader.value="";
          adminShipping.$refs.txtBarcodeReader.focus();
          //spinnerHelpers.hide();
        });
      }
    }
  }
};
</script>

<style scoped>
.fixed-table-body{
  max-height:220px;
}
.card-header{
  padding:7px;
  border-radius: 0px;
}
#tableOCList td{
  padding:5px;
}
.fixed-table-pagination{
  display:none !important;
}
#frmBarcodeReader .btn{
  width:100%;
}
#tabItemList td{
  padding:0px;
}
#tabItemList td div {
    padding: 5px;
}
.div-checked{
  background:#4dbd74;;
  color:#fff;
}
.div-append-feedback-ok{
  padding: 8px 0px;
  background: #4dbd74;
  border-radius: 4px;
  margin-top: 2px;
}
.div-append-feedback-ko{
  padding: 8px 0px;
  background: #D44950;
  border-radius: 4px;
  margin-top: 2px;
}
.div-append-feedback-ok h3, .div-append-feedback-ok i, .div-append-feedback-ko h3, .div-append-feedback-ko i{
  color:#fff;
  font-size: 0.875rem;
  text-align: center;
  margin-bottom: 0px;
}
.app-footer, .breadcrumb {
  display:none;
}
.main .container-fluid {
  padding:0px;
}
.app-header.navbar .navbar-brand {
  background-color:#fff;
  border-bottom:0px;
}
.app-header.navbar .navbar-brand {
    background-image: url(https://www.microdetectors.com/media/image/logo.png);
    background-size: contain;
    width: 150px;
    height: 100%;
}
#cardDetailArticle {
    position: fixed;
    bottom: 0;
    width: 100%;
    margin-bottom: 0px;
}
#btnItemListBack {
  padding: 5px 0px;
}
.app-header .navbar-toggler, .app-header{
  display:none;
}
.app-body {
  padding-top:0px;
}

@media (min-width: 992px) {
  .btn-block {
    display: inline-block;
    width: auto;
    margin-top: 0rem !important;
  }
}
</style>
